export default "__VITE_ASSET__cLZLOsSELI_GmwKcVOKKRw__ 220w";